import type { FaireProductEntity } from "../../entity_types/product";

export const p_w5srf8zjgj: FaireProductEntity = {
  token: "p_w5srf8zjgj",
  type: "product",
  name: "Mahjong Pieces House Slippers for Women",
  brandToken: "b_xkh87elait",
  brandName: "Katydid",
  imageUrl:
    "https://cdn.faire.com/fastly/3b638d8531142ab3c93ae13808473ca8390f46800bf56551229d9848123f6c5e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d12726728caf30d26685b7ac98c62093f1036b5e7cb4c1e2062a1af2ade3809e.jpeg",
    "https://cdn.faire.com/fastly/9426c6245af9192a5f57b1d8ea6afbad65afd20af29eef87cd61376a3a308d06.jpeg",
  ],
  priceDollars: 14,
  description:
    "These fuzzy slippers bring a light, social energy to any collection. The Mahjong Pieces Fuzzy Slippers feel playful, nostalgic, and easy to incorporate into a variety of merchandising stories.\n\nThe design balances color and detail while keeping the overall look approachable. It stands out without overwhelming the product.\n\nWith their plush feel and easy slip-on fit, these sherpa slippers offer comfort customers expect from everyday essentials.\n\nThey integrate naturally into displays with pajama sets, cozy apparel, and gift-focused assortments, making them an easy add-on purchase.\n\nHand wash warm; hang to dry\ns/m fits sizes 6-7, m/l fits sizes 8-9, l/xl fits size 10",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:48.328Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
